import { useEffect } from 'react';

import { useLocation, useNavigate } from '@xing-com/crate-core-router';

export const useLoggedoutAction = (
  toggle: () => void,
  action: string,
  currentValue = false,
  skip?: boolean
) => {
  const navigate = useNavigate();
  const location = useLocation();

  const search = new URLSearchParams(location.search);

  const hasAction = search.get('action') === action;

  useEffect(() => {
    if (hasAction && !currentValue && !skip) {
      toggle();
    }

    if (hasAction && !skip) {
      navigate(location.pathname);
      // history.push({
      //   search: '',
      // });
    }
  }, [hasAction, skip]);

  return null;
};
